<template>
  <div class="about-us">
   <template v-if="$route.name === 'AboutUs'">
    <!-- Banner部分 -->
    <div class="banner">
      <div class="banner-content">
        <h1 class="banner-title">{{ t("aboutkangma.titlle") }}</h1>
        <p class="banner-subtitle">{{ t("aboutkangma.subtitle") }}</p>
      </div>
    </div>

    <!-- 关于我们简介 -->
    <div class="intro-section" ref="introSection">
      <div class="intro-content">
        <h2>{{ t("aboutkangma.intortitel") }}</h2>
        <p>
        <i18n-t keypath="aboutkangma.intorinfo1" tag="span">
          <template #D2P>
            <span  class="bodtext">D2P，DNA-to-Protein</span>
          </template>
        </i18n-t>
      </p>
        <p>
          {{ t("aboutkangma.intorinfo2") }}
        </p>
      </div>
    </div>

    <div class="content-list">
      <!-- 战略目标 -->
      <div class="content-item gird1" ref="contentItem1">
        <div class="text-content">
          <h3>{{ t("aboutkangma.strategicgoals") }}</h3>
          <p>
            {{ t("aboutkangma.strategicgoalsinfo") }}
          </p>
          <div class="learnmore"  @click="goToGoalsPage">
            <span>{{ t("aboutkangma.learnmore") }}</span>
            <span class="right-arrow"><svg data-v-61dd7a3d="" data-v-a41d480e="" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" data-v-f316e37b="">
                <path data-v-61dd7a3d="" data-v-a41d480e="" d="M13 8.66671L16.3333 12L13 15.3334" stroke="currentColor"
                  stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
                <path data-v-61dd7a3d="" data-v-a41d480e="" d="M16.3334 12L7.66675 12" stroke="currentColor"
                  stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg></span>
          </div>
        </div>
        <div class="image-content">
          <img src="@/assets/image/about/aboutus_photo_1.png" :alt="t('aboutkangma.strategicgoals')" />
        </div>
      </div>

      <!-- 我们的技术 -->
      <div class="content-item reverse" ref="contentItem2">
        <div class="text-content">
          <h3>{{ t("aboutkangma.ourtechnology") }}</h3>
          <p>
            {{ t("aboutkangma.ourtechnologyinfo") }}
          </p>
        </div>
        <div class="image-content">
          <img src="@/assets/image/about/aboutus_photo_2.png" :alt="t('aboutkangma.ourtechnology')" />
        </div>
        <div class="bgimg">
          <img src="@/assets/image/about/aboutus_bj_2.png" alt="" />
        </div>
      </div>

      <!-- 我们的产品 -->
      <div class="content-item" ref="contentItem3">
        <div class="text-content">
          <h3>{{ t("aboutkangma.ourproducrts") }}</h3>
          <p>
            {{ t("aboutkangma.ourproducrtsinfo") }}
          </p>
        </div>
        <div class="image-content">
          <img src="@/assets/image/about/aboutus_photo_3.png" :alt="t('aboutkangma.ourproducrts')" />
        </div>
        <div class="bgimg2">
          <img src="@/assets/image/about/aboutus_bj_3.png" alt="" />
        </div>
      </div>

      <!-- 我们的使命 -->
      <div class="content-item reverse" ref="contentItem4">
        <div class="text-content">
          <h3>{{ t("aboutkangma.ourmission") }}</h3>
          <p>
            {{ t("aboutkangma.ourmissioninfo") }}
          </p>
        </div>
        <div class="image-content">
          <img src="@/assets/image/about/aboutus_photo_4.png" :alt="t('aboutkangma.ourmission')" />
        </div>
        <div class="bgimg3">
          <img src="@/assets/image/about/aboutus_bj_4.png" alt="" />
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div class="content-item gird4" ref="contentItem5">
        <div class="text-content">
          <h3>{{ t("aboutkangma.partner") }}</h3>
          <p>
            {{ t("aboutkangma.partnerinfo") }}
          </p>

          <div class="bgimg4">
            <img src="@/assets/image/about/aboutus_bj_5.png" alt="" />
          </div>
                    <div href="" class="learnmore" @click="goToPartnerPage">
            <span>{{ t("aboutkangma.learnmore") }}</span>
            <span class="right-arrow"><svg data-v-61dd7a3d="" data-v-a41d480e="" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg" data-v-f316e37b="">
                <path data-v-61dd7a3d="" data-v-a41d480e="" d="M13 8.66671L16.3333 12L13 15.3334" stroke="currentColor"
                  stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
                <path data-v-61dd7a3d="" data-v-a41d480e="" d="M16.3334 12L7.66675 12" stroke="currentColor"
                  stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg></span>
          </div>
        </div>

        <div class="image-content">
          <img src="@/assets/image/about/aboutus_photo_5.png" :alt="t('aboutkangma.partner')" />
        </div>
      </div>
    </div>
        </template>
       <router-view />
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// 注册ScrollTrigger插件
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "AboutUs",
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimations();
    });
  },
  methods: {
  goToGoalsPage() {
    this.$router.push({ path: "/about/strategicgoals" });
  },
    goToPartnerPage() {
    // 使用编程式导航跳转到合作伙伴页面
    this.$router.push('/about/partner');
  },
    initAnimations() {
      // Banner动画保持不变
      const bannerTitle = document.querySelector(".banner-title");
      const bannerSubtitle = document.querySelector(".banner-subtitle");

      if (bannerTitle) {
        const titleText = bannerTitle.innerText;
        bannerTitle.innerHTML = "";
        titleText.split("").forEach((char, i) => {
          const span = document.createElement("span");
          span.textContent = char;
          span.style.display = "inline-block";
          span.style.opacity = "0";
          span.style.transform = "translateY(30px) rotateY(90deg)";
          bannerTitle.appendChild(span);

          gsap.to(span, {
            opacity: 1,
            y: 0,
            rotationY: 0,
            duration: 0.8,
            delay: i * 0.05,
            ease: "back.out(1.7)",
          });
        });
      }

      if (bannerSubtitle) {
        gsap.fromTo(
          bannerSubtitle,
          {
            opacity: 0,
            x: -50,
          },
          {
            opacity: 1,
            x: 0,
            duration: 1,
            delay: 1.5,
            ease: "power3.out",
          }
        );
      }

      //  简介部分动画
      if (this.$refs.introSection) {
        const introText = this.$refs.introSection.querySelectorAll("p");
        gsap.fromTo(
          this.$refs.introSection.querySelector("h2"),
          {
            opacity: 0,
            y: 50,
            scale: 0.8,
          },
          {
            opacity: 1,
            y: 0,
            scale: 1,
            duration: 1,
            ease: "elastic.out(1, 0.5)",
            scrollTrigger: {
              trigger: this.$refs.introSection,
              start: "top 85%",
              toggleActions: "play none none reverse",
            },
          }
        );

        if (introText) {
          gsap.fromTo(
            introText,
            {
              opacity: 0,
              y: 30,
            },
            {
              opacity: 1,
              y: 0,
              duration: 1.2,
              delay: 0.3,
              scrollTrigger: {
                trigger: this.$refs.introSection,
                start: "top 80%",
                toggleActions: "play none none reverse",
              },
            }
          );
        }
      }

      // 列表项动画
      const contentItems = [
        this.$refs.contentItem1,
        this.$refs.contentItem2,
        this.$refs.contentItem3,
        this.$refs.contentItem4,
        this.$refs.contentItem5,
      ];

      contentItems.forEach((item, index) => {
        if (!item) return;

        const textContent = item.querySelector(".text-content");
        const imageContent = item.querySelector(".image-content");
        const learnMore = textContent
          ? textContent.querySelector(".learnmore")
          : null;
        gsap.set(item, {
          opacity: 0,
          y: 100,
          scale: 0.95,
        });

        // 创建时间线动画 - 整体动画
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: item,
            start: "top 85%",
            end: "top 30%",
            toggleActions: "play none none reverse",
            // markers: true // 调试时可以打开查看触发位置
          },
        });

        // 整个内容项动画 - 从下往上显示
        tl.to(item, {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 1.2,
          ease: "power3.out",
        });

        // 如果有learnmore按钮，添加额外效果
        if (learnMore) {
          gsap.set(learnMore, {
            opacity: 0,
            y: 20,
          });

          // 在整体动画完成后，learnmore按钮单独出现
          tl.to(
            learnMore,
            {
              opacity: 1,
              y: 0,
              duration: 0.6,
              ease: "power2.out",
            },
            "-=0.5"
          ); // 稍微提前一点开始
        }

        // 保留鼠标悬停效果
        if (imageContent) {
          imageContent.addEventListener("mouseenter", () => {
            gsap.to(imageContent, {
              scale: 1.05,
              filter: "brightness(1.1) saturate(1.2)",
              duration: 0.5,
              ease: "power2.out",
            });
          });

          imageContent.addEventListener("mouseleave", () => {
            gsap.to(imageContent, {
              scale: 1,
              filter: "brightness(1) saturate(1)",
              duration: 0.5,
              ease: "power2.out",
            });
          });
        }

        // 为标题添加悬停效果
        const title = textContent ? textContent.querySelector("h3") : null;
        if (title) {
          title.addEventListener("mouseenter", () => {
            gsap.to(title, {
              color: "#000",
              duration: 0.3,
              ease: "power2.out",
            });
          });

          title.addEventListener("mouseleave", () => {
            gsap.to(title, {
              color: "#000",
              duration: 0.3,
              ease: "power2.out",
            });
          });
        }
      });

      const learnMoreButtons = document.querySelectorAll(".learnmore");
      learnMoreButtons.forEach((button) => {
        const arrow = button.querySelector(".right-arrow");

        button.addEventListener("mouseenter", () => {
          gsap.to(arrow, {
            x: 10,
            duration: 0.3,
            ease: "power2.out",
          });
        });

        button.addEventListener("mouseleave", () => {
          gsap.to(arrow, {
            x: 0,
            duration: 0.3,
            ease: "power2.out",
          });
        });
      });
    },
  },
  beforeUnmount() {
    // 清理所有ScrollTrigger实例
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
  },
};
</script>
<style scoped>
.about-us {
  width: 100%;
}

/* Banner样式 */
.banner {
  position: relative;
  width: 100%;
  height: 100vh;
  background: url("@/assets/image/about/aboutus_banner.gif") center/cover;
  display: flex;
  align-items: center;
  color: white;
  text-align: left;
}

.banner-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  padding: 0 20px;
  width: 100%;
  margin-left: 5%;
}

.banner-title {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 400;
}

.banner-subtitle {
  font-size: 1.8rem;
}
.bodtext{
  font-weight: bold;
}

.intro-section {
  padding: 4rem 0;
  height: auto;
  background: url("@/assets/image/about/aboutus_bj_1.png") center/cover no-repeat;
  background-size: contain;
}

.intro-content {
  max-width: 92%;
  margin: 6rem auto;
  text-align: center;
  position: relative;
  z-index: 2;
}

.intro-content h2 {
  font-size: 2rem;
  margin-bottom: 32px;
  font-weight: bold;
  color: #000;
}

.intro-content p {
  font-size: 1.45rem;
  line-height: 2;
  color: #000;
  font-weight: 300;
}



.content-list {
  width: 100%;
  background: #fff;
  position: relative;
  z-index: 3;
}

.content-item {
  display: flex;
  align-items: stretch; 
  margin-bottom: 120px;
  overflow: hidden;
}

.content-item.reverse {
  flex-direction: row-reverse;
}

.text-content {
  flex: 1;
  padding: 4.5rem 4.2rem 2rem 4.2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  position: relative;
  z-index: 1;
  min-height: 100%;
}

.gird1 .text-content,.gird4 .text-content{
  padding: 10rem 4.2rem 2rem 4.2rem;
}

.bgimg {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
}

.bgimg2 {
  position: absolute;
  left: 0;
  bottom: 10px;
  z-index: 0;
}

.bgimg3 {
  position: absolute;
  right: 0;
  top: 25%;
  z-index: 0;
}

.bgimg4 {
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: -1;
}

/* 修改后的 learnmore 样式 - 实现右对齐 */
.text-content .learnmore {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end; 
  font-size: 1.4rem;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem; 
  width: 100%; 
    color: #0d5c9d;
}

.learnmore:hover {
  transform: translateX(5px);
  color: #0d5c9d;
}

.learnmore .right-arrow {
  transition: all 0.2s ease-in-out;
  width: 3.5rem;
  transform: translateX(5px);
}

.banner::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg,
      rgba(0, 0, 0, 0.3) 0%,
      rgba(0, 0, 0, 0.1) 100%);
}

.text-content h3 {
  font-size: 2.4rem;
  margin-bottom: 15px;
  color: #000;
  font-weight: 600;
  transition: color 0.3s ease;
}

.text-content h3:hover {
  color: #117ac7;
}

.text-content p {
  font-size: 1.45rem;
  line-height: 1.8;
  color: #333;
  font-weight: 300;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 9; 
  overflow: hidden;
  text-align: justify;
}

.image-content {
  flex: 1.2; /* 保持比例 */
  min-width: 0;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center; /* 垂直居中图片 */
  justify-content: center; /* 水平居中图片 */
}

.image-content img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 改为 cover 以填充容器 */
  display: block;
}

/* 响应式设计 */
@media screen and (min-width: 1920px) {
  .text-content {
    padding: 5rem 6.2rem;
  }
  .gird1 .text-content, .gird4 .text-content{
    padding: 9rem 6.2rem 0 6.2rem;
  }
  .intro-section {
    padding: 8rem 0;
  }

  .banner-content {
    margin-left: 3%;
  }

  .bgimg2 {
    bottom: 70px;
  }

  .bgimg4 {
    right: 3rem;
  }
  .intro-content{
    width: 88%;
  }
  .text-content .learnmore {
    right: 7rem;
  }
}

@media (max-width: 768px) {
  .banner {
    height: 50vh;
  }
  .gird1 .text-content,.gird4 .text-content{
  padding:2rem;
}

  .banner-title {
    font-size: 2rem;
  }

  .content-item {
    flex-direction: column !important;
    margin-bottom: 60px;
  }

  .text-content {
    padding: 20px;
    width: 100%;
    min-height: auto; 
  }

  .image-content {
    width: 100%;
    height: 300px;
  }

  .image-content img {
    width: 100%;
    height: 100%;
    object-fit: contain; 
    cursor: pointer;
  }

  .banner-content {
    margin: 0 auto;
  }

  .intro-section {
    background-attachment: scroll;
  }
  
  .text-content .learnmore {
    justify-content: flex-end;
    font-size: 1.2rem;
  }
  .bgimg3{
    top: 6%;
  }
  .bgimg2{
    left: 50% !important;
    top: 5%;
  }
}
</style>